// extracted by mini-css-extract-plugin
var _1 = "ResizerHandlers_root__90b67";
var _2 = "ResizerHandlers_visible__88759";
export { _1 as "root", _2 as "visible" }
